/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-writing-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/common/src/pipes/date_pipe';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/i18n/tokens';
import * as import10 from '../shared/config.service';
import * as import11 from '../shared/intl.service';
import * as import12 from '../shared/meta.service';
import * as import13 from '../shared/utils.service';
import * as import14 from '@angular/forms/src/form_builder';
import * as import15 from '@angular/router/src/router';
import * as import16 from '../shared/content.service';
import * as import17 from '@angular/router/src/router_state';
import * as import18 from '@angular/core/src/metadata/view';
import * as import19 from '@angular/core/src/linker/component_factory';
import * as import20 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import21 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '@angular/common/src/pipes/uppercase_pipe';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/common/src/directives/ng_switch';
import * as import25 from '@angular/common/src/directives/ng_if';
import * as import26 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import27 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_control_name.ngfactory';
import * as import30 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import31 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_name.ngfactory';
import * as import32 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import33 from '@angular/core/src/linker/element_ref';
import * as import34 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import35 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import36 from '@angular/forms/src/directives/control_value_accessor';
import * as import37 from '@angular/forms/src/directives/reactive_directives/form_control_name';
import * as import38 from '@angular/forms/src/directives/ng_control';
import * as import39 from '@angular/forms/src/directives/ng_control_status';
import * as import40 from '@angular/forms/src/directives/default_value_accessor';
import * as import41 from '@angular/common/src/directives/ng_for';
import * as import42 from '@angular/forms/src/directives/reactive_directives/form_group_name';
import * as import43 from '@angular/forms/src/directives/control_container';
import * as import44 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import45 from './html-editor.component.ngfactory';
import * as import46 from './html-editor.component';
export class Wrapper_ContentWritingEditComponent {
  context:import0.ContentWritingEditComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any) {
    this.changed = false;
    this.context = new import0.ContentWritingEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentWritingEditComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentWritingEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _DatePipe_0_4:import4.DatePipe;
  _ContentWritingEditComponent_0_5:Wrapper_ContentWritingEditComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent_Host0,renderType_ContentWritingEditComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentWritingEditComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._ContentWritingEditComponent_0_5 = new Wrapper_ContentWritingEditComponent(this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.IntlService),this.parentInjector.get(import12.MetaService),this.parentInjector.get(import13.UtilsService),this._DatePipe_0_4,this.parentInjector.get(import14.FormBuilder),this.parentInjector.get(import15.Router),this.parentInjector.get(import16.ContentService),this.parentInjector.get(import17.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentWritingEditComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentWritingEditComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.DatePipe) && (0 === requestNodeIndex))) { return this._DatePipe_0_4; }
    if (((token === import0.ContentWritingEditComponent) && (0 === requestNodeIndex))) { return this._ContentWritingEditComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentWritingEditComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentWritingEditComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingEditComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentWritingEditComponent_Host === (null as any))) { (renderType_ContentWritingEditComponent_Host = viewUtils.createRenderComponentType('',0,import18.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentWritingEditComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentWritingEditComponentNgFactory:import19.ComponentFactory<import0.ContentWritingEditComponent> = new import19.ComponentFactory<import0.ContentWritingEditComponent>('ng-component',viewFactory_ContentWritingEditComponent_Host0,import0.ContentWritingEditComponent);
const styles_ContentWritingEditComponent:any[] = ([] as any[]);
var renderType_ContentWritingEditComponent:import2.RenderComponentType = (null as any);
class _View_ContentWritingEditComponent0 extends import1.AppView<import0.ContentWritingEditComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _NgSwitch_3_3:import20.Wrapper_NgSwitch;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import20.Wrapper_NgSwitchCase;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgSwitchCase_7_6:import20.Wrapper_NgSwitchCase;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import21.Wrapper_NgIf;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _appEl_11:import3.AppElement;
  _TemplateRef_11_5:any;
  _NgSwitchCase_11_6:import20.Wrapper_NgSwitchCase;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _anchor_25:any;
  /*private*/ _appEl_25:import3.AppElement;
  _TemplateRef_25_5:any;
  _NgIf_25_6:import21.Wrapper_NgIf;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _pipe_date_0:import4.DatePipe;
  _pipe_uppercase_1:import22.UpperCasePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent0,renderType_ContentWritingEditComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'      ',(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content-header'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n          ',(null as any));
    this._el_3 = import5.createRenderElement(this.renderer,this._el_1,'h1',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_3_3 = new import20.Wrapper_NgSwitch();
    this._text_4 = this.renderer.createText(this._el_3,'\n              ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_5 = new import3.AppElement(5,3,this,this._anchor_5);
    this._TemplateRef_5_5 = new import23.TemplateRef_(this._appEl_5,viewFactory_ContentWritingEditComponent1);
    this._NgSwitchCase_5_6 = new import20.Wrapper_NgSwitchCase(this._appEl_5.vcRef,this._TemplateRef_5_5,this._NgSwitch_3_3.context);
    this._text_6 = this.renderer.createText(this._el_3,'\n              ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_7 = new import3.AppElement(7,3,this,this._anchor_7);
    this._TemplateRef_7_5 = new import23.TemplateRef_(this._appEl_7,viewFactory_ContentWritingEditComponent2);
    this._NgSwitchCase_7_6 = new import20.Wrapper_NgSwitchCase(this._appEl_7.vcRef,this._TemplateRef_7_5,this._NgSwitch_3_3.context);
    this._text_8 = this.renderer.createText(this._el_3,'\n              ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_9 = new import3.AppElement(9,3,this,this._anchor_9);
    this._TemplateRef_9_5 = new import23.TemplateRef_(this._appEl_9,viewFactory_ContentWritingEditComponent3);
    this._NgIf_9_6 = new import21.Wrapper_NgIf(this._appEl_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_3,'\n              ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_11 = new import3.AppElement(11,3,this,this._anchor_11);
    this._TemplateRef_11_5 = new import23.TemplateRef_(this._appEl_11,viewFactory_ContentWritingEditComponent4);
    this._NgSwitchCase_11_6 = new import20.Wrapper_NgSwitchCase(this._appEl_11.vcRef,this._TemplateRef_11_5,this._NgSwitch_3_3.context);
    this._text_12 = this.renderer.createText(this._el_3,'\n          ',(null as any));
    this._text_13 = this.renderer.createText(this._el_1,'\n        ',(null as any));
    this._text_14 = this.renderer.createText(parentRenderNode,'\n\n      ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n          ',(null as any));
    this._el_19 = import5.createRenderElement(this.renderer,this._el_17,'div',new import5.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_19,'div',new import5.InlineArray2(2,'class','box'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n              ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_21,'div',new import5.InlineArray2(2,'class','box-body'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n      \n                ',(null as any));
    this._anchor_25 = this.renderer.createTemplateAnchor(this._el_23,(null as any));
    this._appEl_25 = new import3.AppElement(25,23,this,this._anchor_25);
    this._TemplateRef_25_5 = new import23.TemplateRef_(this._appEl_25,viewFactory_ContentWritingEditComponent5);
    this._NgIf_25_6 = new import21.Wrapper_NgIf(this._appEl_25.vcRef,this._TemplateRef_25_5);
    this._text_26 = this.renderer.createText(this._el_23,'\n      \n      \n              ',(null as any));
    this._text_27 = this.renderer.createText(this._el_21,'\n              ',(null as any));
    this._text_28 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._text_29 = this.renderer.createText(this._el_19,'\n          ',(null as any));
    this._text_30 = this.renderer.createText(this._el_17,'\n        ',(null as any));
    this._text_31 = this.renderer.createText(this._el_15,'\n      ',(null as any));
    this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._pipe_uppercase_1 = new import22.UpperCasePipe();
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._anchor_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._text_31
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import24.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    if (((token === import23.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import24.NgSwitchCase) && (7 === requestNodeIndex))) { return this._NgSwitchCase_7_6.context; }
    if (((token === import23.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import25.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import23.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import24.NgSwitchCase) && (11 === requestNodeIndex))) { return this._NgSwitchCase_11_6.context; }
    if (((token === import24.NgSwitch) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._NgSwitch_3_3.context; }
    if (((token === import23.TemplateRef) && (25 === requestNodeIndex))) { return this._TemplateRef_25_5; }
    if (((token === import25.NgIf) && (25 === requestNodeIndex))) { return this._NgIf_25_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = this.context.action;
    this._NgSwitch_3_3.check_ngSwitch(currVal_3_0_0,throwOnChange,false);
    this._NgSwitch_3_3.detectChangesInInputProps(this,this._el_3,throwOnChange);
    const currVal_5_0_0:any = 'add';
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = 'update';
    this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0,throwOnChange,false);
    this._NgSwitchCase_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = (this.context.content && (this.context.action == 'update'));
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.detectChangesInInputProps(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:any = 'update';
    this._NgSwitchCase_11_6.check_ngSwitchCase(currVal_11_0_0,throwOnChange,false);
    this._NgSwitchCase_11_6.detectChangesInInputProps(this,this._anchor_11,throwOnChange);
    const currVal_25_0_0:any = (this.context.content || (this.context.action == 'add'));
    this._NgIf_25_6.check_ngIf(currVal_25_0_0,throwOnChange,false);
    this._NgIf_25_6.detectChangesInInputProps(this,this._anchor_25,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_3_3.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentWritingEditComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentWritingEditComponent> {
  if ((renderType_ContentWritingEditComponent === (null as any))) { (renderType_ContentWritingEditComponent = viewUtils.createRenderComponentType('',0,import18.ViewEncapsulation.None,styles_ContentWritingEditComponent,{})); }
  return new _View_ContentWritingEditComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent1,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Nouvel écrit',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentWritingEditComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent2,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Edition ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_4:any = import5.interpolate(1,'',((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.cid),'');
    if (import5.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingEditComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent3,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','lLink'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Supprimer',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.deleteContent('writing',this.parent.context.content._id)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentWritingEditComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_date_0_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent4,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_date_0_0 = import5.pureProxy2((<_View_ContentWritingEditComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentWritingEditComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import5.interpolate(1,'(modifié: ',valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0,(<_View_ContentWritingEditComponent0>this.parent)._pipe_date_0.transform)(((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.update_date),'dd MMM yyyy')),')');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingEditComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupDirective_0_3:import26.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import27.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _CheckboxControlValueAccessor_13_3:import28.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_13_4:any[];
  _FormControlName_13_5:import29.Wrapper_FormControlName;
  _NgControl_13_6:any;
  _NgControlStatus_13_7:import27.Wrapper_NgControlStatus;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _DefaultValueAccessor_23_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_23_4:any[];
  _FormControlName_23_5:import29.Wrapper_FormControlName;
  _NgControl_23_6:any;
  _NgControlStatus_23_7:import27.Wrapper_NgControlStatus;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  _DefaultValueAccessor_31_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_31_4:any[];
  _FormControlName_31_5:import29.Wrapper_FormControlName;
  _NgControl_31_6:any;
  _NgControlStatus_31_7:import27.Wrapper_NgControlStatus;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _el_37:any;
  _text_38:any;
  _text_39:any;
  _el_40:any;
  _DefaultValueAccessor_40_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_40_4:any[];
  _FormControlName_40_5:import29.Wrapper_FormControlName;
  _NgControl_40_6:any;
  _NgControlStatus_40_7:import27.Wrapper_NgControlStatus;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _FormGroupName_51_3:import31.Wrapper_FormGroupName;
  _ControlContainer_51_4:any;
  _NgControlStatusGroup_51_5:import27.Wrapper_NgControlStatusGroup;
  _text_52:any;
  _anchor_53:any;
  /*private*/ _appEl_53:import3.AppElement;
  _TemplateRef_53_5:any;
  _NgFor_53_6:import32.Wrapper_NgFor;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _el_62:any;
  _FormGroupName_62_3:import31.Wrapper_FormGroupName;
  _ControlContainer_62_4:any;
  _NgControlStatusGroup_62_5:import27.Wrapper_NgControlStatusGroup;
  _text_63:any;
  _anchor_64:any;
  /*private*/ _appEl_64:import3.AppElement;
  _TemplateRef_64_5:any;
  _NgFor_64_6:import32.Wrapper_NgFor;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _FormGroupName_74_3:import31.Wrapper_FormGroupName;
  _ControlContainer_74_4:any;
  _NgControlStatusGroup_74_5:import27.Wrapper_NgControlStatusGroup;
  _text_75:any;
  _anchor_76:any;
  /*private*/ _appEl_76:import3.AppElement;
  _TemplateRef_76_5:any;
  _NgFor_76_6:import32.Wrapper_NgFor;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _text_82:any;
  _el_83:any;
  _FormArrayName_83_3:import31.Wrapper_FormArrayName;
  _ControlContainer_83_4:any;
  _NgControlStatusGroup_83_5:import27.Wrapper_NgControlStatusGroup;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _anchor_87:any;
  /*private*/ _appEl_87:import3.AppElement;
  _TemplateRef_87_5:any;
  _NgFor_87_6:import32.Wrapper_NgFor;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _text_91:any;
  _text_92:any;
  _text_93:any;
  _el_94:any;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  /*private*/ _expr_145:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent5,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_145 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'form',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._FormGroupDirective_0_3 = new import26.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n      \n                  ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','panel panel-default'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n      \n                    ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Métadonnées',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                      ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_7,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','col-md-1 col-sm-1 input-group switch material-switch'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                              ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'input',new import5.InlineArray8(8,'formControlName','active','id','act','name','act','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_13_3 = new import28.Wrapper_CheckboxControlValueAccessor(this.renderer,new import33.ElementRef(this._el_13));
    this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
    this._FormControlName_13_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_13_4);
    this._NgControl_13_6 = this._FormControlName_13_5.context;
    this._NgControlStatus_13_7 = new import27.Wrapper_NgControlStatus(this._NgControl_13_6);
    this._text_14 = this.renderer.createText(this._el_11,'\n                              ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_11,'label',new import5.InlineArray4(4,'class','label-primary','for','act'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','input-group col-lg-3 col-md-3 col-sm-4'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_18,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_20,'i',new import5.InlineArray2(2,'class','fa fa-user'),(null as any));
    this._text_22 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_18,'input',new import5.InlineArray8(6,'class','form-control','formControlName','author','type','text'),(null as any));
    this._DefaultValueAccessor_23_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_23));
    this._NG_VALUE_ACCESSOR_23_4 = [this._DefaultValueAccessor_23_3.context];
    this._FormControlName_23_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_23_4);
    this._NgControl_23_6 = this._FormControlName_23_5.context;
    this._NgControlStatus_23_7 = new import27.Wrapper_NgControlStatus(this._NgControl_23_6);
    this._text_24 = this.renderer.createText(this._el_18,'\n                        ',(null as any));
    this._text_25 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._el_26 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','input-group col-lg-5 col-md-5 col-sm-5'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                            ',(null as any));
    this._el_28 = import5.createRenderElement(this.renderer,this._el_26,'div',new import5.InlineArray2(2,'class','input-group-addon addon-width'),(null as any));
    this._el_29 = import5.createRenderElement(this.renderer,this._el_28,'i',new import5.InlineArray2(2,'class','fa fa-external-link'),(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n                            ',(null as any));
    this._el_31 = import5.createRenderElement(this.renderer,this._el_26,'input',new import5.InlineArray8(6,'class','form-control','formControlName','url','type','text'),(null as any));
    this._DefaultValueAccessor_31_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_31));
    this._NG_VALUE_ACCESSOR_31_4 = [this._DefaultValueAccessor_31_3.context];
    this._FormControlName_31_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_31_4);
    this._NgControl_31_6 = this._FormControlName_31_5.context;
    this._NgControlStatus_31_7 = new import27.Wrapper_NgControlStatus(this._NgControl_31_6);
    this._text_32 = this.renderer.createText(this._el_26,'\n                        ',(null as any));
    this._text_33 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._el_34 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray4(4,'class','input-group col-lg-2 col-md-2 col-sm-5','style','max-width: 200px'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n                          ',(null as any));
    this._el_36 = import5.createRenderElement(this.renderer,this._el_34,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_37 = import5.createRenderElement(this.renderer,this._el_36,'i',new import5.InlineArray2(2,'class','fa fa-calendar'),(null as any));
    this._text_38 = this.renderer.createText(this._el_34,'\n                          ',(null as any));
    this._text_39 = this.renderer.createText(this._el_34,'\n                          ',(null as any));
    this._el_40 = import5.createRenderElement(this.renderer,this._el_34,'input',new import5.InlineArray8(6,'class','form-control','formControlName','date','type','text'),(null as any));
    this._DefaultValueAccessor_40_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_40));
    this._NG_VALUE_ACCESSOR_40_4 = [this._DefaultValueAccessor_40_3.context];
    this._FormControlName_40_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_40_4);
    this._NgControl_40_6 = this._FormControlName_40_5.context;
    this._NgControlStatus_40_7 = new import27.Wrapper_NgControlStatus(this._NgControl_40_6);
    this._text_41 = this.renderer.createText(this._el_34,'\n                        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._text_43 = this.renderer.createText(this._el_9,'\n                      ',(null as any));
    this._text_44 = this.renderer.createText(this._el_7,'\n                    ',(null as any));
    this._text_45 = this.renderer.createText(this._el_2,'\n      \n                    ',(null as any));
    this._el_46 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'Titre',(null as any));
    this._text_48 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                      ',(null as any));
    this._el_51 = import5.createRenderElement(this.renderer,this._el_49,'div',new import5.InlineArray2(2,'formGroupName','title'),(null as any));
    this._FormGroupName_51_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_51_4 = this._FormGroupName_51_3.context;
    this._NgControlStatusGroup_51_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_51_4);
    this._text_52 = this.renderer.createText(this._el_51,'\n                        ',(null as any));
    this._anchor_53 = this.renderer.createTemplateAnchor(this._el_51,(null as any));
    this._appEl_53 = new import3.AppElement(53,51,this,this._anchor_53);
    this._TemplateRef_53_5 = new import23.TemplateRef_(this._appEl_53,viewFactory_ContentWritingEditComponent6);
    this._NgFor_53_6 = new import32.Wrapper_NgFor(this._appEl_53.vcRef,this._TemplateRef_53_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_54 = this.renderer.createText(this._el_51,'\n                      ',(null as any));
    this._text_55 = this.renderer.createText(this._el_49,'\n                    ',(null as any));
    this._text_56 = this.renderer.createText(this._el_2,'\n\n                    ',(null as any));
    this._el_57 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'Résumé',(null as any));
    this._text_59 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_60 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n                      ',(null as any));
    this._el_62 = import5.createRenderElement(this.renderer,this._el_60,'div',new import5.InlineArray2(2,'formGroupName','summary'),(null as any));
    this._FormGroupName_62_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_62_4 = this._FormGroupName_62_3.context;
    this._NgControlStatusGroup_62_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_62_4);
    this._text_63 = this.renderer.createText(this._el_62,'\n                        ',(null as any));
    this._anchor_64 = this.renderer.createTemplateAnchor(this._el_62,(null as any));
    this._appEl_64 = new import3.AppElement(64,62,this,this._anchor_64);
    this._TemplateRef_64_5 = new import23.TemplateRef_(this._appEl_64,viewFactory_ContentWritingEditComponent7);
    this._NgFor_64_6 = new import32.Wrapper_NgFor(this._appEl_64.vcRef,this._TemplateRef_64_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_65 = this.renderer.createText(this._el_62,'\n                      ',(null as any));
    this._text_66 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_2,'\n',(null as any));
    this._text_68 = this.renderer.createText(this._el_2,'\n\n                    ',(null as any));
    this._el_69 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'Contenu',(null as any));
    this._text_71 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_72 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                      ',(null as any));
    this._el_74 = import5.createRenderElement(this.renderer,this._el_72,'div',new import5.InlineArray2(2,'formGroupName','content'),(null as any));
    this._FormGroupName_74_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_74_4 = this._FormGroupName_74_3.context;
    this._NgControlStatusGroup_74_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_74_4);
    this._text_75 = this.renderer.createText(this._el_74,'\n                        ',(null as any));
    this._anchor_76 = this.renderer.createTemplateAnchor(this._el_74,(null as any));
    this._appEl_76 = new import3.AppElement(76,74,this,this._anchor_76);
    this._TemplateRef_76_5 = new import23.TemplateRef_(this._appEl_76,viewFactory_ContentWritingEditComponent8);
    this._NgFor_76_6 = new import32.Wrapper_NgFor(this._appEl_76.vcRef,this._TemplateRef_76_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_77 = this.renderer.createText(this._el_74,'\n                      ',(null as any));
    this._text_78 = this.renderer.createText(this._el_72,'\n                    ',(null as any));
    this._text_79 = this.renderer.createText(this._el_2,'\n      \n                    ',(null as any));
    this._el_80 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'Tags',(null as any));
    this._text_82 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_83 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray4(4,'class','panel-body','formArrayName','tags'),(null as any));
    this._FormArrayName_83_3 = new import31.Wrapper_FormArrayName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_83_4 = this._FormArrayName_83_3.context;
    this._NgControlStatusGroup_83_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_83_4);
    this._text_84 = this.renderer.createText(this._el_83,'\n                      ',(null as any));
    this._el_85 = import5.createRenderElement(this.renderer,this._el_83,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'\n                        ',(null as any));
    this._anchor_87 = this.renderer.createTemplateAnchor(this._el_85,(null as any));
    this._appEl_87 = new import3.AppElement(87,85,this,this._anchor_87);
    this._TemplateRef_87_5 = new import23.TemplateRef_(this._appEl_87,viewFactory_ContentWritingEditComponent9);
    this._NgFor_87_6 = new import32.Wrapper_NgFor(this._appEl_87.vcRef,this._TemplateRef_87_5,this.parent.parentInjector.get(import34.IterableDiffers),this.parent.ref);
    this._text_88 = this.renderer.createText(this._el_85,'\n                        ',(null as any));
    this._el_89 = import5.createRenderElement(this.renderer,this._el_85,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-plus clickLink'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,' ',(null as any));
    this._text_91 = this.renderer.createText(this._el_85,'\n                      ',(null as any));
    this._text_92 = this.renderer.createText(this._el_83,'\n                    ',(null as any));
    this._text_93 = this.renderer.createText(this._el_2,'\n      \n                    ',(null as any));
    this._el_94 = import5.createRenderElement(this.renderer,this._el_2,'button',new import5.InlineArray4(4,'class','btn btn-info pull-right','type','submit'),(null as any));
    this._text_95 = this.renderer.createText(this._el_94,'\n              Sauvegarder\n            ',(null as any));
    this._text_96 = this.renderer.createText(this._el_2,'\n      \n                  ',(null as any));
    this._text_97 = this.renderer.createText(this._el_0,'\n      \n                ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_13,'change',this.eventHandler(this._handle_change_13_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_13,'blur',this.eventHandler(this._handle_blur_13_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_23,'input',this.eventHandler(this._handle_input_23_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_23,'blur',this.eventHandler(this._handle_blur_23_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_31,'ngModelChange',this.eventHandler(this._handle_ngModelChange_31_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_31,'input',this.eventHandler(this._handle_input_31_1.bind(this)));
    var disposable_9:Function = this.renderer.listen(this._el_31,'blur',this.eventHandler(this._handle_blur_31_2.bind(this)));
    const subscription_1:any = this._FormControlName_31_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_31_0.bind(this)));
    var disposable_10:Function = this.renderer.listen(this._el_40,'input',this.eventHandler(this._handle_input_40_0.bind(this)));
    var disposable_11:Function = this.renderer.listen(this._el_40,'blur',this.eventHandler(this._handle_blur_40_1.bind(this)));
    var disposable_12:Function = this.renderer.listen(this._el_89,'click',this.eventHandler(this._handle_click_89_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._el_37,
      this._text_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._anchor_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._anchor_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._anchor_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._anchor_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._text_91,
      this._text_92,
      this._text_93,
      this._el_94,
      this._text_95,
      this._text_96,
      this._text_97
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10,
      disposable_11,
      disposable_12
    ]
    ,[
      subscription_0,
      subscription_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_13_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_13_4; }
    if (((token === import37.FormControlName) && (13 === requestNodeIndex))) { return this._FormControlName_13_5.context; }
    if (((token === import38.NgControl) && (13 === requestNodeIndex))) { return this._NgControl_13_6; }
    if (((token === import39.NgControlStatus) && (13 === requestNodeIndex))) { return this._NgControlStatus_13_7.context; }
    if (((token === import40.DefaultValueAccessor) && (23 === requestNodeIndex))) { return this._DefaultValueAccessor_23_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (23 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_23_4; }
    if (((token === import37.FormControlName) && (23 === requestNodeIndex))) { return this._FormControlName_23_5.context; }
    if (((token === import38.NgControl) && (23 === requestNodeIndex))) { return this._NgControl_23_6; }
    if (((token === import39.NgControlStatus) && (23 === requestNodeIndex))) { return this._NgControlStatus_23_7.context; }
    if (((token === import40.DefaultValueAccessor) && (31 === requestNodeIndex))) { return this._DefaultValueAccessor_31_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (31 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_31_4; }
    if (((token === import37.FormControlName) && (31 === requestNodeIndex))) { return this._FormControlName_31_5.context; }
    if (((token === import38.NgControl) && (31 === requestNodeIndex))) { return this._NgControl_31_6; }
    if (((token === import39.NgControlStatus) && (31 === requestNodeIndex))) { return this._NgControlStatus_31_7.context; }
    if (((token === import40.DefaultValueAccessor) && (40 === requestNodeIndex))) { return this._DefaultValueAccessor_40_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (40 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_40_4; }
    if (((token === import37.FormControlName) && (40 === requestNodeIndex))) { return this._FormControlName_40_5.context; }
    if (((token === import38.NgControl) && (40 === requestNodeIndex))) { return this._NgControl_40_6; }
    if (((token === import39.NgControlStatus) && (40 === requestNodeIndex))) { return this._NgControlStatus_40_7.context; }
    if (((token === import23.TemplateRef) && (53 === requestNodeIndex))) { return this._TemplateRef_53_5; }
    if (((token === import41.NgFor) && (53 === requestNodeIndex))) { return this._NgFor_53_6.context; }
    if (((token === import42.FormGroupName) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._FormGroupName_51_3.context; }
    if (((token === import43.ControlContainer) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._ControlContainer_51_4; }
    if (((token === import39.NgControlStatusGroup) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) { return this._NgControlStatusGroup_51_5.context; }
    if (((token === import23.TemplateRef) && (64 === requestNodeIndex))) { return this._TemplateRef_64_5; }
    if (((token === import41.NgFor) && (64 === requestNodeIndex))) { return this._NgFor_64_6.context; }
    if (((token === import42.FormGroupName) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._FormGroupName_62_3.context; }
    if (((token === import43.ControlContainer) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._ControlContainer_62_4; }
    if (((token === import39.NgControlStatusGroup) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) { return this._NgControlStatusGroup_62_5.context; }
    if (((token === import23.TemplateRef) && (76 === requestNodeIndex))) { return this._TemplateRef_76_5; }
    if (((token === import41.NgFor) && (76 === requestNodeIndex))) { return this._NgFor_76_6.context; }
    if (((token === import42.FormGroupName) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._FormGroupName_74_3.context; }
    if (((token === import43.ControlContainer) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._ControlContainer_74_4; }
    if (((token === import39.NgControlStatusGroup) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._NgControlStatusGroup_74_5.context; }
    if (((token === import23.TemplateRef) && (87 === requestNodeIndex))) { return this._TemplateRef_87_5; }
    if (((token === import41.NgFor) && (87 === requestNodeIndex))) { return this._NgFor_87_6.context; }
    if (((token === import42.FormArrayName) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) { return this._FormArrayName_83_3.context; }
    if (((token === import43.ControlContainer) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) { return this._ControlContainer_83_4; }
    if (((token === import39.NgControlStatusGroup) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) { return this._NgControlStatusGroup_83_5.context; }
    if (((token === import44.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import43.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) { return this._ControlContainer_0_4; }
    if (((token === import39.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.writingForm;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this,this._el_13,throwOnChange);
    const currVal_13_1_0:any = 'active';
    this._FormControlName_13_5.check_name(currVal_13_1_0,throwOnChange,false);
    this._FormControlName_13_5.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_23_3.detectChangesInInputProps(this,this._el_23,throwOnChange);
    const currVal_23_1_0:any = 'author';
    this._FormControlName_23_5.check_name(currVal_23_1_0,throwOnChange,false);
    this._FormControlName_23_5.detectChangesInInputProps(this,this._el_23,throwOnChange);
    this._NgControlStatus_23_7.detectChangesInInputProps(this,this._el_23,throwOnChange);
    this._DefaultValueAccessor_31_3.detectChangesInInputProps(this,this._el_31,throwOnChange);
    const currVal_31_1_0:any = 'url';
    this._FormControlName_31_5.check_name(currVal_31_1_0,throwOnChange,false);
    const currVal_31_1_1:any = this.parent.context.url;
    this._FormControlName_31_5.check_model(currVal_31_1_1,throwOnChange,false);
    this._FormControlName_31_5.detectChangesInInputProps(this,this._el_31,throwOnChange);
    this._NgControlStatus_31_7.detectChangesInInputProps(this,this._el_31,throwOnChange);
    this._DefaultValueAccessor_40_3.detectChangesInInputProps(this,this._el_40,throwOnChange);
    const currVal_40_1_0:any = 'date';
    this._FormControlName_40_5.check_name(currVal_40_1_0,throwOnChange,false);
    this._FormControlName_40_5.detectChangesInInputProps(this,this._el_40,throwOnChange);
    this._NgControlStatus_40_7.detectChangesInInputProps(this,this._el_40,throwOnChange);
    const currVal_51_0_0:any = 'title';
    this._FormGroupName_51_3.check_name(currVal_51_0_0,throwOnChange,false);
    this._FormGroupName_51_3.detectChangesInInputProps(this,this._el_51,throwOnChange);
    this._NgControlStatusGroup_51_5.detectChangesInInputProps(this,this._el_51,throwOnChange);
    const currVal_53_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_53_6.check_ngForOf(currVal_53_0_0,throwOnChange,false);
    this._NgFor_53_6.detectChangesInInputProps(this,this._anchor_53,throwOnChange);
    const currVal_62_0_0:any = 'summary';
    this._FormGroupName_62_3.check_name(currVal_62_0_0,throwOnChange,false);
    this._FormGroupName_62_3.detectChangesInInputProps(this,this._el_62,throwOnChange);
    this._NgControlStatusGroup_62_5.detectChangesInInputProps(this,this._el_62,throwOnChange);
    const currVal_64_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_64_6.check_ngForOf(currVal_64_0_0,throwOnChange,false);
    this._NgFor_64_6.detectChangesInInputProps(this,this._anchor_64,throwOnChange);
    const currVal_74_0_0:any = 'content';
    this._FormGroupName_74_3.check_name(currVal_74_0_0,throwOnChange,false);
    this._FormGroupName_74_3.detectChangesInInputProps(this,this._el_74,throwOnChange);
    this._NgControlStatusGroup_74_5.detectChangesInInputProps(this,this._el_74,throwOnChange);
    const currVal_76_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_76_6.check_ngForOf(currVal_76_0_0,throwOnChange,false);
    this._NgFor_76_6.detectChangesInInputProps(this,this._anchor_76,throwOnChange);
    const currVal_83_0_0:any = 'tags';
    this._FormArrayName_83_3.check_name(currVal_83_0_0,throwOnChange,false);
    this._FormArrayName_83_3.detectChangesInInputProps(this,this._el_83,throwOnChange);
    this._NgControlStatusGroup_83_5.detectChangesInInputProps(this,this._el_83,throwOnChange);
    const currVal_87_0_0:any = this.parent.context.writingForm.controls.tags.controls;
    this._NgFor_87_6.check_ngForOf(currVal_87_0_0,throwOnChange,false);
    this._NgFor_87_6.detectChangesInInputProps(this,this._anchor_87,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupDirective_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._FormControlName_13_5.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_23_3.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._FormControlName_23_5.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._NgControlStatus_23_7.detectChangesInHostProps(this,this._el_23,throwOnChange);
    this._DefaultValueAccessor_31_3.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._FormControlName_31_5.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._NgControlStatus_31_7.detectChangesInHostProps(this,this._el_31,throwOnChange);
    this._DefaultValueAccessor_40_3.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._FormControlName_40_5.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._NgControlStatus_40_7.detectChangesInHostProps(this,this._el_40,throwOnChange);
    this._FormGroupName_51_3.detectChangesInHostProps(this,this._el_51,throwOnChange);
    this._NgControlStatusGroup_51_5.detectChangesInHostProps(this,this._el_51,throwOnChange);
    this._FormGroupName_62_3.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._NgControlStatusGroup_62_5.detectChangesInHostProps(this,this._el_62,throwOnChange);
    this._FormGroupName_74_3.detectChangesInHostProps(this,this._el_74,throwOnChange);
    this._NgControlStatusGroup_74_5.detectChangesInHostProps(this,this._el_74,throwOnChange);
    this._FormArrayName_83_3.detectChangesInHostProps(this,this._el_83,throwOnChange);
    this._NgControlStatusGroup_83_5.detectChangesInHostProps(this,this._el_83,throwOnChange);
    const currVal_145:boolean = !this.parent.context.writingForm.valid;
    if (import5.checkBinding(throwOnChange,this._expr_145,currVal_145)) {
      this.renderer.setElementProperty(this._el_94,'disabled',currVal_145);
      this._expr_145 = currVal_145;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_13_5.context.ngOnDestroy();
    this._FormControlName_23_5.context.ngOnDestroy();
    this._FormControlName_31_5.context.ngOnDestroy();
    this._FormControlName_40_5.context.ngOnDestroy();
    this._FormArrayName_83_3.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_change_13_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_13_0);
  }
  private _handle_blur_13_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onTouched()) !== false);
    return (true && pd_13_0);
  }
  private _handle_input_23_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this._DefaultValueAccessor_23_3.context.onChange($event.target.value)) !== false);
    return (true && pd_23_0);
  }
  private _handle_blur_23_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this._DefaultValueAccessor_23_3.context.onTouched()) !== false);
    return (true && pd_23_0);
  }
  private _handle_ngModelChange_31_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>(this.parent.context.url = $event)) !== false);
    return (true && pd_31_0);
  }
  private _handle_input_31_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>this._DefaultValueAccessor_31_3.context.onChange($event.target.value)) !== false);
    return (true && pd_31_0);
  }
  private _handle_blur_31_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_31_0:any = ((<any>this._DefaultValueAccessor_31_3.context.onTouched()) !== false);
    return (true && pd_31_0);
  }
  private _handle_input_40_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_40_0:any = ((<any>this._DefaultValueAccessor_40_3.context.onChange($event.target.value)) !== false);
    return (true && pd_40_0);
  }
  private _handle_blur_40_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_40_0:any = ((<any>this._DefaultValueAccessor_40_3.context.onTouched()) !== false);
    return (true && pd_40_0);
  }
  private _handle_click_89_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_89_0:any = ((<any>this.parent.context.onAddTag()) !== false);
    return (true && pd_89_0);
  }
}
function viewFactory_ContentWritingEditComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import29.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import27.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent6,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import29.Wrapper_FormControlName((<_View_ContentWritingEditComponent5>this.parent)._ControlContainer_51_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_uppercase_1_0 = import5.pureProxy1((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import37.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import38.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0,(<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentWritingEditComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import29.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import27.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent7,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'textarea',new import5.InlineArray8(6,'class','form-control','rows','3','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import29.Wrapper_FormControlName((<_View_ContentWritingEditComponent5>this.parent)._ControlContainer_62_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_uppercase_1_1 = import5.pureProxy1((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import37.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import38.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1,(<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentWritingEditComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _HtmlEditorComponent_5_4:import45.Wrapper_HtmlEditorComponent;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_10:any;
  _pipe_uppercase_1_2:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent8,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'html-editor',new import5.InlineArray2(2,'height','50'),(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._el_5);
    var compView_5:any = import45.viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
    this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context,([] as any[]),compView_5);
    this._text_6 = this.renderer.createText((null as any),'\n                          ',(null as any));
    compView_5.create(this._HtmlEditorComponent_5_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_uppercase_1_2 = import5.pureProxy1((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'onEditorKeyup',this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    const subscription_0:any = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._HtmlEditorComponent_5_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_5_0_0:any = ('editor-content-' + this.context.$implicit);
    this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = (this.parent.parent.context.content? this.parent.parent.context.content.content[this.context.$implicit]: '');
    this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1,throwOnChange,false);
    const currVal_5_0_2:any = '50';
    this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2,throwOnChange,false);
    this._HtmlEditorComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2,(<_View_ContentWritingEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this._HtmlEditorComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_5_4.context.ngOnDestroy();
  }
  private _handle_onEditorKeyup_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.keyupEditorHandlerFunction([
      'content',
      this.context.$implicit
    ]
    ,$event)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentWritingEditComponent8(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingEditComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _DefaultValueAccessor_2_3:import30.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_2_4:any[];
  _FormControlName_2_5:import29.Wrapper_FormControlName;
  _NgControl_2_6:any;
  _NgControlStatus_2_7:import27.Wrapper_NgControlStatus;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _text_6:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingEditComponent9,renderType_ContentWritingEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray4(4,'class','input-group col-lg-3 col-md-4 col-sm-5','style','padding: 0px 3px 3px 0px; max-width: 200px'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_2_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer,new import33.ElementRef(this._el_2));
    this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
    this._FormControlName_2_5 = new import29.Wrapper_FormControlName((<_View_ContentWritingEditComponent5>this.parent)._ControlContainer_83_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_2_4);
    this._NgControl_2_6 = this._FormControlName_2_5.context;
    this._NgControlStatus_2_7 = new import27.Wrapper_NgControlStatus(this._NgControl_2_6);
    this._text_3 = this.renderer.createText(this._el_0,'\n                          ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_4,'a',new import5.InlineArray2(2,'class','glyphicon glyphicon-remove clickLink'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'input',this.eventHandler(this._handle_input_2_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_2,'blur',this.eventHandler(this._handle_blur_2_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.DefaultValueAccessor) && (2 === requestNodeIndex))) { return this._DefaultValueAccessor_2_3.context; }
    if (((token === import36.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_2_4; }
    if (((token === import37.FormControlName) && (2 === requestNodeIndex))) { return this._FormControlName_2_5.context; }
    if (((token === import38.NgControl) && (2 === requestNodeIndex))) { return this._NgControl_2_6; }
    if (((token === import39.NgControlStatus) && (2 === requestNodeIndex))) { return this._NgControlStatus_2_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultValueAccessor_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_2_1_0:any = import5.interpolate(1,'',this.context.index,'');
    this._FormControlName_2_5.check_name(currVal_2_1_0,throwOnChange,false);
    this._FormControlName_2_5.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._DefaultValueAccessor_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._FormControlName_2_5.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this._NgControlStatus_2_7.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_2_5.context.ngOnDestroy();
  }
  private _handle_input_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onChange($event.target.value)) !== false);
    return (true && pd_2_0);
  }
  private _handle_blur_2_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this._DefaultValueAccessor_2_3.context.onTouched()) !== false);
    return (true && pd_2_0);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.onRemoveTag(this.context.index)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentWritingEditComponent9(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingEditComponent9(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-writing-edit.component.ngfactory.ts